export enum OverlayClose {
  Cancel = 1,
  Confirm = 2,
}
